import React from "react"
import TextField from "@mui/material/TextField"
import Autocomplete from '@mui/material/Autocomplete';
import Grid from "@mui/material/Grid"

import { useFormik } from 'formik';
import * as Yup from 'yup';

import {useTranslation} from "react-i18next"

import AppButton from "app/components/shared/AppButton/AppButton.tsx"
import {ButtonTypeEnum, ButtonSizeEnum} from "app/components/shared/enums/global-enums.tsx"


import useStore from 'app/store/store'

export default function AddKnowledgeComponent({setOpenAddKC}){

  const {t} = useTranslation();
  const storeActions = useStore((state) => state.actions);
  const course = useStore((state) => state.course);

  const elmNames = [...new Set(course.knowledge_components.map((elem)=>elem.title))];

  const ElmSchema = Yup.object().shape({
    title: Yup.string()
      .min(2, 'Too Short!')
      .required('Required')
  });

  const formik = useFormik({
    initialValues: {
      title: '',
    },
    validationSchema: ElmSchema,
    onSubmit: (values) => {
      storeActions.createKnowledgeComponent({knowledge_component: values, courseId: course.id}, ()=>setOpenAddKC(false));
    },
  });

  return (
    <div className="add-knowledge-component">
      <form onSubmit={formik.handleSubmit}>
        <Grid item xs={12}  className="spec-height">
          <Grid container sx={{paddingLeft: 1, paddingRight: 1} } rowSpacing={1}>
            <Grid item xs={12} className="d-f ai-c jc-sb">
              <Grid item xs={4} className="d-f jc-r bold" >
                Knowledge of &nbsp;
              </Grid>
              <Grid item xs>
                {
                  course.id &&
                 <Autocomplete
                    className="w-100"
                    freeSolo
                    options={
                      elmNames
                    }
                    id="title"
                    value={formik.values.title}
                    name="title"
                    renderInput={(params) => <TextField  {...params} 
                    size="small" label={t("...")}
                    error={formik.touched.title && Boolean(formik.errors.title)}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    />}
                    onInputChange={(event, value) => 
                      {formik.values.title = value}
                    }
                 />
                }
              </Grid>
            </Grid>
            
            <Grid item xs={12} className="d-f ai-c jc-sb">
              <AppButton 
               buttonType={ButtonTypeEnum.TEXT_OUTLINE} 
               buttonLabel={t("Cancel")}
               buttonSize={ButtonSizeEnum.SMALL}
               onClickFunc={()=>setOpenAddKC(false)}

               />

              <AppButton 
               buttonType={ButtonTypeEnum.DEFAULT} 
               buttonLabel={t("Create Knowledge Component")}
               buttonSize={ButtonSizeEnum.SMALL}
               actionType="submit"
               />
            </Grid>
          </Grid>  
        </Grid>
      </form>
    </div>
  );
}